import useTableRequest from "../../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import {
  courseEnrollmentsReportColumns,
  usersCourseEnrollmentsReportColumns,
} from "../../../constant/tables-columns/tablesColums";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import moment from "jalali-moment";
import UserCourseEnrollmentsReportsFilter from "./CourseEnrollmentsReportsFilter";
import { convertDate } from "../../../utils/convertDate";

export default function CourseEnrollmentsReports() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [userReportsData, setUsersReportsData] = useState([]);

  const getProductReports = async (params) => {
    const path = "admin/courseEnrollments/withoutPaginate";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      const mapData = response?.data?.result?.map((item) => {
        return {
          name: item.user.name,
          mobile: item.user.mobile,
          نماینده: item.ref?.name,
          "شماره تماس نماینده": item.ref?.mobile,
          courseName: item.course.name,
          paymentStatus: item.paymentStatus,
          createdAt: convertDate(item.createdAt),
        };
      });
      setUsersReportsData(mapData);
    });
  };

  useEffect(() => {
    getProductReports({});
  }, []);
  useEffect(() => {
    filterDataHandler({
      from: moment().locale("en").format("YYYY-MM-DD"),
      to: moment().locale("en").format("YYYY-MM-DD"),
    });
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"لیست تراکنش های دوره ها"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel disabled={tableRequest.status !== "success"} jsonData={userReportsData} />
        </div>
      </div>
      <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">تراکنش‌های ثبت‌نام دوره را همراه با خریدار، نماینده و وضعیت پرداخت در بازهٔ تاریخ نشان می‌دهد.</p>
      <UserCourseEnrollmentsReportsFilter
        filterDataHandler={filterDataHandler}
      />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={courseEnrollmentsReportColumns} rows={userReportsData} />
    </div>
  );
}
